export default "__VITE_ASSET__BGljoz7y__"